// apps/web/src/lib/utils.ts
// The canonical shadcn `cn()` helper. Used by every shadcn component.

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
